import * as fromDatatype from '../datatype-library/index';

export interface bl_mrp_job_order_bin_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_mrp_job_order_bin_link_RowClass implements bl_mrp_job_order_bin_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
}